import { RouterModule, Routes } from '@angular/router';

import { AccessibilityGuard } from '../../../auth/accessibility.guard';
import { AuthGuardService } from './../../../auth/auth-guard.service';
import { CommonModule } from '@angular/common';
import {NgModule} from '@angular/core';
import { OrderDetailComponent } from './dialog/order.detail.component';
import { OrderTransferComponent } from './dialog/order.transfer.component';
import { SalesInquiryComponent } from './sales-inquiry.component';
import { SharedModule } from '../../../template/shared/shared.module';

const routes: Routes = [{
    path: '',
    children: [
        {
            path: 'index',
            component: SalesInquiryComponent,
            canActivate: [AuthGuardService],
            data: {breadcrumb: 'Index'}
        }
    ]
}];


@NgModule({
    imports: [
    CommonModule,
        RouterModule.forChild(routes),
        SharedModule
    ],
    declarations: [
        SalesInquiryComponent,
        OrderTransferComponent,
        OrderDetailComponent
    ],
    providers: []
})

export class SalesInquiryModule {
}